import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-newcollateral',
  templateUrl: './newcollateral.component.html',
  styleUrls: ['./newcollateral.component.css']
})
export class NewcollateralComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
